import { Typography } from '@mui/material';
import StatusBadge from 'components/new/StatusBadge';
import { OnboardingStepStatus } from 'further-types/lp/onboarding';
import { Row } from 'further-ui/components/Layout';

const getStatusLabel = (status?: OnboardingStepStatus) => {
  switch (status) {
    case OnboardingStepStatus.Requested:
    case OnboardingStepStatus.StartedByInvestor:
      return 'Awaiting completion';
    case OnboardingStepStatus.InReview:
      return 'Completed, awaiting approval';
    case OnboardingStepStatus.Completed:
      return 'Completed';
    case OnboardingStepStatus.MoreInformationRequested:
      return 'Awaiting additional information';
  }
};

const statusColor = {
  [OnboardingStepStatus.Disabled]: 'error',
  [OnboardingStepStatus.Requested]: 'error',
  [OnboardingStepStatus.StartedByInvestor]: 'error',
  [OnboardingStepStatus.InReview]: 'warning',
  [OnboardingStepStatus.Completed]: 'success',
  [OnboardingStepStatus.MoreInformationRequested]: 'warning',
} as const;

type Props = {
  status: OnboardingStepStatus;
};

const JourneyStepStatus: React.FC<Props> = ({ status }) => {
  if (status === OnboardingStepStatus.Disabled) return null;

  return (
    <Row centered spacing="xs">
      <StatusBadge color={statusColor[status]} />
      <Typography variant="h6">{getStatusLabel(status)}</Typography>
    </Row>
  );
};

export default JourneyStepStatus;
